import { getOpDef } from '../transform-vocab.js';
import { DslEvaluateError } from './errors.js';
/** Helper: invoke an existing TransformOpDef.evaluate by id with positional args mapped to a config key list. */
function bridgeOp(opId, argToConfig) {
    return (args, ctx) => {
        const op = getOpDef(opId);
        if (!op)
            throw new DslEvaluateError(`Built-in op missing from vocab: ${opId}`);
        const { input, config } = argToConfig(args);
        return op.evaluate(input, config, ctx);
    };
}
export const BUILTIN_DSL_FUNCTIONS = {
    // --- string family ---
    trim: bridgeOp('trim', ([value]) => ({ input: value, config: {} })),
    upper: bridgeOp('case', ([value]) => ({ input: value, config: { mode: 'upper' } })),
    lower: bridgeOp('case', ([value]) => ({ input: value, config: { mode: 'lower' } })),
    case: bridgeOp('case', ([value, mode]) => ({ input: value, config: { mode } })),
    slice: bridgeOp('slice', ([value, start, end]) => ({
        input: value,
        config: { start, ...(end !== undefined ? { end } : {}) },
    })),
    pad: bridgeOp('pad', ([value, length, side, fill]) => ({
        input: value,
        config: { length, side, char: fill },
    })),
    regex_replace: bridgeOp('regex_replace', ([value, pattern, replacement]) => ({
        input: value,
        config: { pattern, replacement },
    })),
    default_if_empty: bridgeOp('default_if_empty', ([value, fallback]) => ({
        input: value,
        config: { literal: fallback },
    })),
};
// --- number family ---
BUILTIN_DSL_FUNCTIONS.number_format = bridgeOp('number_format', ([value, decimals]) => ({
    input: value,
    config: { decimals },
}));
// --- date family ---
BUILTIN_DSL_FUNCTIONS.date_format = bridgeOp('date_format', ([value, format]) => ({
    input: value,
    config: { outputFormat: format },
}));
// --- literal family ---
BUILTIN_DSL_FUNCTIONS.set_literal = bridgeOp('set_literal', ([literal]) => ({
    input: null,
    config: { literal },
}));
BUILTIN_DSL_FUNCTIONS.append_literal = bridgeOp('append_literal', ([value, suffix]) => ({
    input: value,
    config: { literal: suffix },
}));
// --- lookup family ---
BUILTIN_DSL_FUNCTIONS.lookup_table = bridgeOp('lookup_table', ([tableId, key]) => ({
    input: key,
    config: { tableId },
}));
// --- logic family — implement directly because they aren't in the existing op-vocab as functions ---
BUILTIN_DSL_FUNCTIONS.eq = (args) => String(args[0]) === String(args[1]) ? 'true' : 'false';
BUILTIN_DSL_FUNCTIONS.gt = (args) => Number(args[0]) > Number(args[1]) ? 'true' : 'false';
BUILTIN_DSL_FUNCTIONS.lt = (args) => Number(args[0]) < Number(args[1]) ? 'true' : 'false';
BUILTIN_DSL_FUNCTIONS.gte = (args) => Number(args[0]) >= Number(args[1]) ? 'true' : 'false';
BUILTIN_DSL_FUNCTIONS.lte = (args) => Number(args[0]) <= Number(args[1]) ? 'true' : 'false';
BUILTIN_DSL_FUNCTIONS.not = ([a]) => String(a) === 'true' ? 'false' : 'true';
BUILTIN_DSL_FUNCTIONS.and = ([a, b]) => (String(a) === 'true' && String(b) === 'true') ? 'true' : 'false';
BUILTIN_DSL_FUNCTIONS.or = ([a, b]) => (String(a) === 'true' || String(b) === 'true') ? 'true' : 'false';
//# sourceMappingURL=builtins.js.map